import React from "react";

import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
const ConfirmationModal = ({ isOpen, onClose, onConfirmation }) => {
  const { t } = useTranslation();
  return (
    <Modal show={isOpen} onHide={onClose} centered  size="md">
      <Modal.Header closeButton>
        <Modal.Title>{t("counter-reset-confirmation-message")}</Modal.Title>
      </Modal.Header>
      {/* <Modal.Body>Are you sure you want to reset the counter?</Modal.Body> */}
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button style={{ background: "#6200ee" }} onClick={onConfirmation}>
          {t("counter-reset-confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
